import React, { useCallback, useState, forwardRef } from 'react';
import { RenderComponentDropArea } from '../ComponentDropArea';
import DnDContext from '../DnDContext';
import classnames from 'classnames'
import DraggableComponent from './DraggableComponent';
import { DnD_element_type, DnD_element_type_category, DnD_element_type_menu } from '../common/ConstantValues';
import Row from '../ChatService/Row';
import { allowed_types_component, allowed_types_component_menu } from './DropContext';
import NormalComponentContainer from './NormalComponentContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faClone } from '@fortawesome/free-solid-svg-icons';
import { faClone } from '@fortawesome/free-regular-svg-icons';

import './SlidePage.css'

const SlidePage = forwardRef((props, ref) => {
  // Normal props
  const {
    component,
    type,
    col, 
  } = props
  // Indexes
  const {
    message_index, 
    row_index, 
    component_index,
    editing_row_index,
  } = props

  // Functions
  const { 
    onDragStart, 
    onDragEnd,
    handlePageOnClick,
    handleSideAreaOnDrop,
    handleLastAddPageBtn,
    setFirstPageHeight,
    onCopy,
    messageActions,
  } = props
  
  // For UI, Flags
  const { 
    isLast,
    isMultiRow, 
    overContent,
    wrapStyle,
    renderType,
    noDropArea,
    dropAreaAllowTypes,
    disable,
    activateCopy,
    isDragging,
  } = props

  const [ renderedHeight, setRenderedHeight ] = useState(null)
  const [ isMouseHover, setIsMouseHover ] = useState(false)
  
  const isDepth = type.type === DnD_element_type.COMPONENT.NORMAL.GROUP
  
  const slidePageRef = useCallback((node) => {
    if (node) {
      if (component_index === 0) {
        setFirstPageHeight(node.offsetHeight)
      }
      setRenderedHeight(node.offsetHeight)
    }
  }, [])

  /**
   * 페이지 클릭
   * @param {Object} e 
   */
  const handleOnClick = (e) => {
    handlePageOnClick(component_index)
  }

  /**
   * 페이지 마우스 호버
   * @param {Object} e 
   */
  const handleOnMouseOver = (e) => {
    setIsMouseHover(true)
  }

  /**
   * 페이지 마우스 호버상태 해제
   * @param {Object} e 
   */
  const handleOnMouseLeave = (e) => {
    setIsMouseHover(false)
  }

  const handleOnClickCopyBtn = (e) => {
    console.log('onCopy :', onCopy);
    onCopy(
      message_index,
      row_index,
      component_index,
    )
  }

  const _renderedHeight = ref ? ref.current ? ref.current.offsetHeight : renderedHeight : renderedHeight
  const _overContent = () => (
    <div style={{minHeight: _renderedHeight, backgroundColor: '#007bff', opacity: 0.5, verticalAlign: 'top', borderRadius: 10+'px',}}>
    </div>
  )

  const dropAreaClassname = classnames('common-style uni-drop-area', {
    'sm-h': !isMultiRow
  })

  // const pageMaskClassname = classnames('page-mask', {
  //   'activated': isMoFHover
  // })

  const rightDialogClassname = classnames('right-dialog', {
    'on': isMouseHover
  })

  return (
    <React.Fragment>
      <DraggableComponentWrap
        messageIndex={message_index}
        rowIndex={row_index}
        componentIndex={component_index+1}
        onDragStart={onDragStart} 
        onDragEnd={onDragEnd}
        dragHandle={verticalHandle()}
        renderedHeight={_renderedHeight}
        type={type.type === 'GROUP' ? DnD_element_type.ELEMENT.SLIDE_PAGE : type.type === 'BUTTON' ? DnD_element_type.COMPONENT.NORMAL.BUTTON.inDepth : DnD_element_type.COMPONENT.NORMAL.IMAGE.inDepth}
        verticalHandle={true}
        contentWidth={200}
        cat_type={DnD_element_type_category.REN_ELEM}
        disableDrag={disable}
      >
        <div 
          ref={ref ? ref : slidePageRef} 
          id={`slide-page-${component_index}`} 
          class='common-style component slide-page' 
          style={{cursor: isMultiRow ? 'pointer' : 'default', minHeight: isMultiRow ? undefined : 40, boxShadow: isMultiRow ? undefined : 'none'}} 
          data-page-index={component_index} 
          onClick={handleOnClick}
          onMouseOver={handleOnMouseOver}
          onMouseLeave={handleOnMouseLeave}
          >
          {/* <div class={pageMaskClassname} style={{height: isMouseHover ? renderedHeight : 0}}>
            <p>수정</p>
          </div> */}
          {
            isMultiRow ? (
              renderGroup(component)
            ) : (
              <NormalComponentContainer {...component} 
                key={component.local_id}
                index={component_index}
                onDrop={(e) => {console.log('e :', e);}}
                message_index={message_index}
                row_index={row_index}
                // row_index_detail={row_index_detail}
                editing_row_index={editing_row_index}
                component_index={component_index+1}
                renderType={renderType}
                attr={type.type}
                isDragging={isDragging}
                noDrag={true}
                noDropArea={noDropArea}
                col={col}
                messageActions={messageActions}
              />
            )
          }
        </div>
      </DraggableComponentWrap>
      {
        isDepth && (
          <div className={rightDialogClassname}
            onClick={handleOnClickCopyBtn}
            onMouseOver={handleOnMouseOver}
            onMouseLeave={handleOnMouseLeave}>
            <div className='copy-page'>
              <FontAwesomeIcon icon={faClone} />
              복사
            </div>
          </div>
        )
      }
      <div class={dropAreaClassname} style={{minHeight: _renderedHeight}}>
        <RenderComponentDropArea
          key={component_index}
          onDrop={(e) => {handleSideAreaOnDrop({...e, component_index_target: component_index+1})}}
          // DnDOverContent={null}
          DnDOverContent={_overContent}
          overContentArg={null}
          // overContentArg={}
          allowed_types={dropAreaAllowTypes}
          customStyle={{display:'inline-block', width: 30, minHeight: _renderedHeight, marginTop: 10}}
        />
      </div>
      {
        isLast && (
          <div class="common-style add-page" onClick={handleLastAddPageBtn} style={{minHeight: _renderedHeight}}>
            {/* {getIcon('add')} */}
            {/* <MaterialIcon icon='add' size='large' /> */}
          </div>
        )
      }
    </React.Fragment>
  )
})

/**
 * Render Component slide layout/ Group
 */

// Group
const renderGroup = (component) => {
  const { rows } = component
  return (
    rows ?
      rows.map((row, i) => (
        <Row
          key={i}
          {...row} />
      )) : (
        <div> No rows </div>
      )
  )
}

const DraggableComponentWrap = (props) => {
  return (
    <DnDContext>
      <DraggableComponent dragHandle={verticalHandle()} {...props}>
        {props.children}
      </DraggableComponent>
    </DnDContext>
  )
}

const verticalHandle = () => (
  <div class='drag-handle'>
  </div>
)

export default SlidePage